module.exports = __webpack_public_path__ + "static/img/6areaA_3.9a1b958.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダー系/6areaA_3.png
// module id = 964
// module chunks = 1